var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pill",style:({ 'color': _vm.getColorClass(this.status).font, 'background-color': _vm.getColorClass(this.status).background })},[_vm._v(" "+_vm._s(this.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }